var FONTS;
(function (FONTS) {
    FONTS["REGULAR"] = "Inter-Regular";
    FONTS["MEDIUM"] = "Inter-Medium";
    FONTS["SEMIBOLD"] = "Inter-SemiBold";
    FONTS["BOLD"] = "Inter-Bold";
})(FONTS || (FONTS = {}));
var FONTS$1 = FONTS;

export { FONTS$1 as default };
//# sourceMappingURL=fonts.js.map
